import { render, staticRenderFns } from "./PageTemplateWithWebPartial.vue?vue&type=template&id=60812840&scoped=true&"
import script from "./PageTemplateWithWebPartial.vue?vue&type=script&lang=js&"
export * from "./PageTemplateWithWebPartial.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplateWithWebPartial.vue?vue&type=style&index=0&id=60812840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60812840",
  null
  
)

export default component.exports